import theme from '@vromo/ui/components/theme';

export default {
    cookieBanner: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: 'white',
        borderRadius: 4,
        position: 'absolute',
        bottom: 40,
        width: '80%',
        left: '10%',
        height: 80,
        alignItems: 'center',
        justifyContent: 'center'
    },
    cookieText: {
        color: theme.darkGrey,
        fontSize: 14,
        paddingRight: 100,
        marginLeft: 28,
        marginRight: 28
    },
    cookieButton: {
        position: 'absolute',
        right: 40
    },
    loading: {
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'flex',
        flex: 1,
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center'
    }
};
